import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TrendInspiration from '~/components/molecules/Editorial/Trend/TrendInspiration.vue';
export default {
  name: 'CollectionInspiration',
  components: {
    TrendInspiration: TrendInspiration
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;

      return {
        background: {
          small: formatPrismicImage((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.background_pattern) != null ? (_ref13 = _ref13.small) != null ? _ref13.url : _ref13 : _ref13 : _ref13 : _ref13) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.background_pattern) != null ? (_ref12 = _ref12.large) != null ? _ref12.url : _ref12 : _ref12 : _ref12 : _ref12) || EMPTY_PIXEL
        },
        reference: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.reference : _ref11 : _ref11) || '',
        image: {
          small: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.image) != null ? (_ref10 = _ref10.small) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.medium) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? (_ref8 = _ref8.image) != null ? (_ref8 = _ref8.large) != null ? _ref8.url : _ref8 : _ref8 : _ref8 : _ref8) || EMPTY_PIXEL,
          alt: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.alt : _ref7 : _ref7) || ''
        },
        text: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.text : _ref6 : _ref6) || '',
        negativeText: this.negative(((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.negative_text : _ref5 : _ref5) || ''),
        negativeIcon: this.negative(((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.negative_icon : _ref4 : _ref4) || ''),
        tracking: {
          data: {
            event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
            event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
            event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
          }
        }
      };
    }
  },
  methods: {
    negative: function negative(arg) {
      return arg === 'black';
    }
  }
};